/* eslint-disable */
import axios, { AxiosResponse } from 'axios';
import React, { useState, useEffect, useRef, useCallback, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './styles/style.module.scss';
import Plans from './layouts/plans';
import Footer from '../../layouts/footer';
import Button from '../../components/ui/button/Button';
import { useStore } from '../../store/store';
import { debounce } from 'lodash';
import { selectProducts } from 'core/store/billing/selectors';
import { useRemoteConfig } from 'core/hooks/use-remote-config';
import { t } from '@web-solutions/module-localization';
import getLocale from '../../../localization/get-locale';
import { getEnvUrl } from 'src/onboarding/helpers/getEnvUrl';

import { EmailPopup } from 'src/onboarding/components/ui/email-popup/EmailPopup';
import { GiftPopup } from 'src/onboarding/components/ui/gift-popup/GiftPopup';
import { CustomersComponent } from './layouts/customers';
import { UsersTrustComponent } from './layouts/usersTrust';
import { GetSelfieReportPopup } from 'src/onboarding/components/ui/GetSelfieReportPopup/GetSelfieReportPopup';

import voeryLogo from '../../assets/images/logo.png';
import { Typography } from 'src/onboarding/components/typography-voery/Typography';
import { AppStoreAppComponent } from './layouts/appStoreApp';
import { FeaturesComponent } from './layouts/features';
import { QuestionsComponent } from './layouts/questions';
import { VoeryCallComponent } from './layouts/voeryCall';
import { useHideOnScroll } from 'src/onboarding/hooks/useHideOnScroll';
import { useBottomButtonVisibility } from 'src/onboarding/hooks/useBottomButtonVisible';
import { usePayment } from 'core/payment/payment-processor-provider/paymentProcessorContext';
import { useNav } from 'src/onboarding/hooks/nav';
import SuccessPayment from '../webUpsale/components/successPaymentPopup';
import instance from 'src/onboarding/api/interceptor';
import { reInit as reInitRemoteConfig } from '@web-solutions/core/store/remote-config/actions';
import { init } from 'core/store/billing/actions';
import { processEmail } from 'core/store/profile/actions';

declare const gtag: Function;

const EMAIL_POPUP_KEY = 'email_popup_shown';
const GIFT_POPUP_KEY = 'gift_popup_shown';

interface PlansRef {
  onPayment: () => void;
}

function addDaysToDate(days: string): string {
  const daysNumber = parseInt(days, 10);
  if (isNaN(daysNumber)) {
    return '';
  }

  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + daysNumber);

  const formatter = new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
  const formattedDate = formatter.format(currentDate);
  return formattedDate;
}

const DynamicPersonalPlan = () => {
  const locale = getLocale();
  const childRef = useRef<PlansRef>(null);
  const pageRef = useRef(null);
  const state = useStore((state) => state);
  const { savedOnboarding, existTimeoutId, setEmail } = state;

  const productsObj = useSelector(selectProducts);
  const {
    specialOffer,
    products,
    routeGroups: flow,
    showEmailPopup,
    showGiftPopup,
    personalPlanPage,
    scrollEnabled,
    showGetSelfieReportPopup,
  } = useRemoteConfig();

  const { ppRef, callbacksRef } = usePayment();
  const { onNext } = useNav();

  const [showDownSaleModalOnce, setShowDownSaleModalOnce] = useState(false);
  const [isEmailPopupOpen, setIsEmailPopupOpen] = useState(
    false && !sessionStorage.getItem(EMAIL_POPUP_KEY)
  );
  const [isGiftPopupOpen, setIsGiftPopupOpen] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showCheck, setShowCheck] = useState(false);

  const scrollRef = useRef(null);
  const headerHidden = useHideOnScroll(scrollRef);
  const showBottomButton = useBottomButtonVisibility(scrollRef);

  useEffect(() => {
    if (isEmailPopupOpen) {
      const scrollY = window.scrollY;

      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';

      return () => {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';

        window.scrollTo(0, scrollY);
      };
    }
  }, [isEmailPopupOpen]);

  useEffect(() => {
    if (showEmailPopup && !sessionStorage.getItem(EMAIL_POPUP_KEY)) {
      setIsEmailPopupOpen(true);
    } else if (showGiftPopup && !sessionStorage.getItem(GIFT_POPUP_KEY)) {
      setIsGiftPopupOpen(true);
    }
  }, []);

  const handleEmailPopupClose = () => {
    setIsEmailPopupOpen(false);
    sessionStorage.setItem(EMAIL_POPUP_KEY, 'true');

    if (showGiftPopup && !sessionStorage.getItem(GIFT_POPUP_KEY)) {
      setIsGiftPopupOpen(true);
    }
  };

  const handleGiftPopupClose = () => {
    setIsGiftPopupOpen(false);
    sessionStorage.setItem(GIFT_POPUP_KEY, 'true');
  };

  const { apiBaseUrl } = getEnvUrl();

  useEffect(() => {
    gtag('event', 'conversion', {
      send_to: 'AW-17149973324/gwbSCMu_yP0aEMym3_E_',
      value: 1.5,
      currency: 'USD',
    });
  }, []);

  useEffect(() => {
    return () => {
      clearTimeout(existTimeoutId);
    };
  }, [existTimeoutId]);

  console.log('products ', products);
  const productDescription = showDownSaleModalOnce
    ? {
        name: specialOffer.products[0]?.name,
        plan_end_days: addDaysToDate(specialOffer.products[0]?.plan_end_days),
        subTitle: specialOffer.products[0]?.subTitle[locale],
        title: specialOffer.products[0]?.title[locale],
        price: specialOffer.products[0]?.priceStartTrial.price,
      }
    : {
        name: products[0]?.name,
        plan_end_days: addDaysToDate(products[0]?.priceStartTrial.plan_end_days),
        subTitle: products[0]?.subTitle[locale],
        title: products[0]?.title[locale],
        price: products[0]?.priceStartTrial.price[locale],
      };
  const { name, plan_end_days, subTitle, title, price } = productDescription;

  const targetRef = useRef(null);

  const scrollToTarget = () => {
    if (targetRef.current) {
      targetRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  const payment = () => {
    //@ts-ignore
    callbacksRef.current = {
      onSuccess: (data) => {
        setShowSuccessPopup(true);
        setTimeout(() => setShowCheck(true), 400);
        setTimeout(() => onNext(), 1800);
      },
      onError: (data) => console.log('error', data),
    };

    ppRef.current?.showPaymentPopup();
  };

  useEffect(() => {
    if (showEmailPopup && isEmailPopupOpen) {
      return;
    }
  }, [savedOnboarding, showEmailPopup, isEmailPopupOpen]);

  const sectionComponents = {
    button: (
      <Button
        className={styles.startTrialBtn}
        title={personalPlanPage.buttonTitle[locale]}
        onClick={
          //@ts-ignore
          scrollEnabled && personalPlanPage?.sections?.includes('try-foodzee')
            ? scrollToTarget
            : payment
        }
      />
    ),
    'payment-button': (
      <Button
        className={styles.startTrialBtn}
        title={personalPlanPage.paymentButtonTitle[locale] || personalPlanPage.buttonTitle[locale]}
        onClick={payment}
      />
    ),
    'users-trust': <UsersTrustComponent />,
    plans: (
      <>
        <Plans
          ref={childRef}
          showDownSaleModalOnce={showDownSaleModalOnce}
          setShowDownSaleModalOnce={setShowDownSaleModalOnce}
          scrollToTarget={scrollToTarget}
          //@ts-ignore
          hasTryFoodzeeSection={personalPlanPage?.sections?.includes('try-foodzee')}
        />

        {/* <span className={styles.privacy}>
          {t('onboarding.personalPlan.plan.accept')}{' '}
          <a onClick={() => setPage('privacy-policy')}>
            {t('onboarding.personalPlan.plan.privacy')}
          </a>
          , <a onClick={() => setPage('terms-of-use')}>{t('onboarding.personalPlan.plan.terms')}</a>
        </span>
        {showPlanDescription && (
          <span className={styles.privacy}>
            {t('onboarding.personalPlan.plan.planExpires')} {plan_end_days}.{' '}
            {t('onboarding.personalPlan.plan.harged')} {subTitle}{' '}
            {t('onboarding.personalPlan.plan.for')} {title},{' '}
            {t('onboarding.personalPlan.plan.then')} {price}.{' '}
            {t('onboarding.personalPlan.plan.last')}
          </span>
        )} */}
      </>
    ),
    'app-store-app': <AppStoreAppComponent />,
    features: <FeaturesComponent />,
    'customers-review': <CustomersComponent />,
    questions: <QuestionsComponent />,
    'voery-call': <VoeryCallComponent />,
  };

  const handleSuccessClose = () => {
    setShowSuccessPopup(false);
    setShowCheck(false);
    onNext();
  };

  const dispatch = useDispatch();

  const params = new URLSearchParams(window.location.search);
  const flowParam = params.get('flow');
  const idParam = params.get('id');
  const isSubscriptionFlow = flowParam === 'subscription';

  useEffect(() => {
    if (!isSubscriptionFlow || !idParam) return;

    const fetchEmail = async () => {
      try {
        const { data } = await instance.get(`/profile/${idParam}/email`);
        //@ts-ignore
        if (data.email) {
          setEmail(data.email);
          //@ts-ignore
          dispatch(processEmail(data.email));
          dispatch(reInitRemoteConfig());
          dispatch(init());
        }
      } catch (e) {
        console.error('Failed to fetch email:', e);
      }
    };

    fetchEmail();
  }, []);

  return (
    <>
      <div className={styles.page} ref={pageRef}>
        <div ref={scrollRef} className={styles.scrollContainer}>
          <div className={`${styles.pageHeader} ${headerHidden ? styles.headerHidden : ''}`}>
            <div className={styles.logoContainer}>
              <img src={voeryLogo} alt='voery logo' />
              <div className={styles.logoDescr}>
                <Typography variant='h3-bold' className={styles.logoTitle}>
                  {t('onboarding.voeryPersonalPlan.voery')}
                </Typography>
                <Typography variant='caption-tabBar'>
                  {t('onboarding.voeryPersonalPlan.aiCall')}
                </Typography>
              </div>
            </div>
            <Button
              className={styles.startTrialBtn}
              title={
                personalPlanPage.paymentButtonTitle[locale] || personalPlanPage.buttonTitle[locale]
              }
              onClick={payment}
            />
          </div>

          {/* <div className={`${styles.floatingButton} ${showFloatingButton ? styles.buttonVisible : ''}`}>
        <Button
          title={personalPlanPage.buttonTitle[locale]}
          onClick={scrollToTarget}
        />
      </div> */}

          <div className={styles.container}>
            <div className={styles.bodyContainer}>
              {personalPlanPage.title && (
                <Typography variant='largeTitle2-bold' className={styles.title}>
                  {personalPlanPage.title[locale]}
                </Typography>
              )}
              {personalPlanPage.subTitle && (
                <Typography variant='callout-medium' className={styles.subTitle}>
                  {personalPlanPage.subTitle[locale]}
                </Typography>
              )}

              {personalPlanPage.sections?.map((section, index) => (
                <Fragment key={`${section}-${index}`}>{sectionComponents[section]}</Fragment>
              ))}
            </div>
          </div>
          <Footer />
        </div>
        <div className={`${styles.bottomButtonWrapper} ${!showBottomButton ? styles.hidden : ''}`}>
          <Button
            className={styles.startTrialBtn}
            title={
              personalPlanPage.paymentButtonTitle[locale] || personalPlanPage.buttonTitle[locale]
            }
            onClick={payment}
          />
        </div>
      </div>

      {/* <Timer
        payment={
          //@ts-ignore
          personalPlanPage?.sections?.includes('try-foodzee') && scrollEnabled
            ? scrollToTarget
            : payment
        }
        showDownSaleModalOnce={showDownSaleModalOnce}
        timerDesign={timerDesign}
      /> */}
      {showSuccessPopup && <SuccessPayment onClose={handleSuccessClose} showCheck={showCheck} />}
      {showEmailPopup && <EmailPopup isOpen={isEmailPopupOpen} onClose={handleEmailPopupClose} />}

      {showGiftPopup && <GiftPopup isOpen={isGiftPopupOpen} onClose={handleGiftPopupClose} />}
    </>
  );
};

const Timer = ({ payment, showDownSaleModalOnce, timerDesign }) => {
  const [timeLeft, setTimeLeft] = useState(595);
  const [isTimerVisible, setIsTimerVisible] = useState(true);
  const locale = getLocale();

  useEffect(() => {
    if (showDownSaleModalOnce) {
      setIsTimerVisible(false);
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timer);
          setIsTimerVisible(false);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [showDownSaleModalOnce]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  return (
    <>
      {isTimerVisible && !showDownSaleModalOnce && (
        <div className={styles.timer}>
          <div className={styles.time}>
            <span className={styles.timeExpire}>{timerDesign.text[locale]}</span>
            <span style={{ color: '#E768B0' }}>{formatTime(timeLeft)}</span>
          </div>
          <Button title={timerDesign.buttonTitle[locale]} onClick={payment} />
        </div>
      )}
    </>
  );
};

export default DynamicPersonalPlan;
